module.exports = __webpack_public_path__ + "img/dab_sara.b10c2ecf.jpg";